import moment from 'moment'
import { cadenceLabel } from 'features/compliance/obligationConstants'

const UNIT_SINGULAR = { week: 'Weekly', month: 'Monthly', year: 'Yearly', day: 'Daily' }
const UNIT_PLURAL = { week: 'weeks', month: 'months', year: 'years', day: 'days' }
const WEEKDAYS = ['Sundays', 'Mondays', 'Tuesdays', 'Wednesdays', 'Thursdays', 'Fridays', 'Saturdays']

export const recurrenceLabel = (task) => {
  if (!task || task.recurrenceType !== 'repeating') return null
  const n = Number(task.recurrenceInterval) || 1
  const unit = task.recurrenceUnit || 'month'
  const base = n === 1
    ? (UNIT_SINGULAR[unit] || 'Repeating')
    : `Every ${n} ${UNIT_PLURAL[unit] || `${unit}s`}`
  if (unit === 'week' && task.recurrenceStartDate) {
    const day = WEEKDAYS[moment(task.recurrenceStartDate).day()]
    if (day) return `${base} on ${day}`
  }
  return base
}

export const taskCadenceLabel = (task) => {
  if (!task) return null
  const recurring = recurrenceLabel(task)
  if (recurring) return recurring
  const cadenceDays = task.complianceObligation?.cadenceDays
  if (cadenceDays) {
    const label = cadenceLabel(cadenceDays)
    return label === 'Not scheduled' ? null : label
  }
  return null
}
